import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '../../axios/axiosInstance';

export const useLoginMember = () =>
  useMutation(async ({ params }) => {
    const { data } = await axiosInstance.post(`/api/auth/member/login`, { ...params });
    return data;
  });
